/* Store module to handle Menu */
import Vue from 'vue';
import EventBus from '@/core/event-bus.js';

const state = {
  menu: [],
  menuRoles: [],
  isLoading: false,
};

const mutations = {
  menu(state, payload) {
    state.menu = payload;
  },
  isLoading(state, payload) {
    state.isLoading = payload;
  },
  menuRoles(state, payload) {
    state.menuRoles = payload;
  },
};

const getters = {
  menu: state => {
    return state.menu;
  },
  isLoading: state => {
    return state.isLoading;
  },
  menuRoles: state => {
    return state.menuRoles;
  },
};

const actions = {
  get: async (context, params) => {
    if (state.isLoading) return;
    const path = 'menu';
    context.commit('isLoading', true);

    let response = {};
    try {
      response = await Vue.axios.get(path, params);
    } catch (error) {
      EventBus.$emit('toast', {
        type: 'error',
        msg: error.response.data.message,
        request: path,
      });
    }
    if (response && response.status === 200) {
      const data = response.data;
      context.commit('menu', data.result);
    }
    context.commit('isLoading', false);
  },
  getRoles: async (context, params) => {
    try {
      let response = await Vue.axios.get('menu/roles', params);
      if (response && response.status === 200) {
        context.commit('menuRoles', response.data);
      }
    } catch (error) {}
  },
  patchRoles: async (context, params) => {
    try {
      let response = await Vue.axios.patch('menu/roles', params);
      if (response && response.status === 200) {
        context.commit('menuRoles', response.data);
      }
    } catch (error) {}
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
